import { render, staticRenderFns } from "./CursorChanger.vue?vue&type=template&id=39261c78&scoped=true&"
import script from "./CursorChanger.vue?vue&type=script&lang=js&"
export * from "./CursorChanger.vue?vue&type=script&lang=js&"
import style0 from "./CursorChanger.vue?vue&type=style&index=0&id=39261c78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39261c78",
  null
  
)

export default component.exports